// Dark Mode Toggle Functionality
class DarkModeToggle {
    constructor() {
        this.toggleButtons = document.querySelectorAll('.darkmode-toggle');
        this.lightLabels = document.querySelectorAll('.light-label');
        this.darkLabels = document.querySelectorAll('.dark-label');
        this.storageKey = 'musiltech-dark-mode';
        
        this.init();
    }

    init() {
        if (this.toggleButtons.length === 0) {
            console.warn('Dark mode toggle buttons not found');
            return;
        }

        // Load saved preference or default to light mode
        const savedMode = localStorage.getItem(this.storageKey);
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const isDarkMode = savedMode === 'dark' || (!savedMode && prefersDark);

        if (isDarkMode) {
            this.enableDarkMode();
        }

        // Add click event listener to all toggle buttons
        this.toggleButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.toggle();
            });
        });

        // Listen for system theme changes
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
            if (!localStorage.getItem(this.storageKey)) {
                if (e.matches) {
                    this.enableDarkMode();
                } else {
                    this.enableLightMode();
                }
            }
        });
    }

    toggle() {
        const isDarkMode = document.body.classList.contains('dark-mode');
        
        if (isDarkMode) {
            this.enableLightMode();
        } else {
            this.enableDarkMode();
        }
    }

    enableDarkMode() {
        document.body.classList.add('dark-mode');
        document.documentElement.setAttribute('data-bs-theme', 'dark');
        
        // Update all instances
        this.lightLabels.forEach(label => label?.classList.add('d-none'));
        this.darkLabels.forEach(label => label?.classList.remove('d-none'));
        this.toggleButtons.forEach(button => button?.setAttribute('aria-pressed', 'true'));
        
        localStorage.setItem(this.storageKey, 'dark');
    }

    enableLightMode() {
        document.body.classList.remove('dark-mode');
        document.documentElement.setAttribute('data-bs-theme', 'light');
        
        // Update all instances
        this.lightLabels.forEach(label => label?.classList.remove('d-none'));
        this.darkLabels.forEach(label => label?.classList.add('d-none'));
        this.toggleButtons.forEach(button => button?.setAttribute('aria-pressed', 'false'));
        
        localStorage.setItem(this.storageKey, 'light');
    }
}

// Initialize dark mode toggle when DOM is ready
function initDarkMode() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new DarkModeToggle();
        });
    } else {
        // DOM is already ready
        new DarkModeToggle();
    }
}

// Initialize immediately
initDarkMode();

export default DarkModeToggle;
